import {makeStyles} from 'tss-react/mui'

export const useStyles = makeStyles()(() => ({
  tableContainer: {
    maxHeight: '20vh'
  }
}))
